<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_copy_operation_title' | translate }}</h4>
  <form #form="ngForm">
    <div class="row">
      <div class="col">
        <mat-form-field>
          <mat-label color="accent">{{ 'common_field_project_name' | translate }}</mat-label>
          <input #searchBox matInput (input)="filterChanged(searchBox.value)" />
        </mat-form-field>
      </div>
    </div>
    <div class="div-tree">
      <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" [(ngModel)]="data.solutionId" [ngModelOptions]="{ standalone: true }">
        <mat-tree class="tree-copy-operation" [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node class="radio-node" *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
            <button mat-icon-button disabled></button>
            <mat-radio-button [value]="node.id">{{ node.displayName }} </mat-radio-button>
          </mat-tree-node>

          <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
            <button mat-icon-button disabled></button>
          </mat-tree-node>

          <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.displayName">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <span>{{ node.displayName }}</span>
          </mat-tree-node>
        </mat-tree>
      </mat-radio-group>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onClickBack()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data" color="accent">{{ 'common_btn_add' | translate }}</button>
    </div>
  </form>
</div>
